import { render, staticRenderFns } from "./catalog-filter-info.vue?vue&type=template&id=7cc67856&"
import script from "./catalog-filter-info.vue?vue&type=script&lang=ts&"
export * from "./catalog-filter-info.vue?vue&type=script&lang=ts&"
import style0 from "./catalog-filter-info.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Video: require('/home/bitrix/www/frontend/components/video/video.vue').default})
